module.exports = __webpack_public_path__ + "img/banner.cc29605f.jpg";